module.exports = __webpack_public_path__ + "img/2.715b93ff.png";